import Gapcursor from '@tiptap/extension-gapcursor';

export default Gapcursor.configure({
  allowGapCursor: true,
});
